import { Component } from "@angular/core";
import { BmLoadingTableComponent } from "../bm-loading-table/bm-loading-table.component";

@Component({
  selector: 'app-bm-loading-state',
  templateUrl: './bm-loading-state.component.html',
  styleUrl: '../../budget-table/table-budget-model.component.scss',
  standalone: true,
  imports: [
    BmLoadingTableComponent,
  ],
})
export class BmLoadingStateComponent {}
